import { HeartIcon } from '../components/Icons';

export default function WishlistPage({ wishlistIds = [], onToggleWishlist, products = [], onNavigate }) {
  const wishedProducts = products.filter(p => wishlistIds.includes(p.id));

  return (
    <div className="min-h-screen bg-[#FAF3F0]">
      {/* Header */}
      <div className="px-4 lg:px-8 py-5 flex items-center bg-white border-b border-gray-100 sticky top-0 z-30">
        <h1 className="text-lg font-black text-[#1A1A2E] tracking-tight">My Wishlist</h1>
      </div>

      {wishedProducts.length === 0 ? (
        <div className="flex items-center justify-center px-4 pb-28 lg:pb-8" style={{ minHeight: 'calc(100vh - 80px)' }}>
          <div className="bg-[#DDDDE8] rounded-2xl p-8 max-w-sm w-full flex flex-col items-center text-center shadow-sm">
            <HeartIcon className="w-12 h-12 text-[#F47B20] mb-3" />
            <h3 className="font-bold text-[#1A1A2E] text-lg mb-2">Your wishlist is empty</h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              Products you like will appear here so you can share or buy later.
            </p>
            <button
              onClick={() => onNavigate('shop')}
              className="mt-6 px-6 py-2.5 bg-[#F47B20] hover:bg-[#D96A10] text-white text-sm font-bold rounded-xl transition-colors"
            >
              Start Shopping
            </button>
          </div>
        </div>
      ) : (
        <div className="w-full mx-auto px-4 lg:px-12 xl:px-16 py-6 pb-28">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:auto-grid-products gap-4 lg:gap-6">
            {wishedProducts.map(p => (
              <div key={p.id} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm relative group flex flex-col">
                <button
                  onClick={() => onToggleWishlist(p.id)}
                  className="absolute top-2 right-2 p-1.5 bg-white/80 backdrop-blur-md rounded-full text-[#F47B20] shadow hover:scale-110 transition-transform z-10"
                >
                  <HeartIcon className="w-4 h-4" filled={true} />
                </button>
                <div
                  className="aspect-[4/5] bg-gray-50 cursor-pointer overflow-hidden"
                  onClick={() => onNavigate('productdetail', { product: p })}
                >
                  {p.image ? (
                    <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-200">
                      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  )}
                </div>
                <div className="p-3 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xs font-bold text-[#1A1A2E] leading-tight line-clamp-2">{p.name}</h3>
                    <p className="text-gray-400 text-[10px] mt-1">{p.category}</p>
                  </div>
                  <div className="mt-2 font-black text-[#F47B20] text-sm">
                    {p.priceStr || `₦${Number(p.price || 0).toLocaleString()}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
